import React, { useState, useEffect } from "react"
import Stepper from "react-stepper-horizontal"
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    CardText,
    Input,
    Row,
    Spinner,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    CardFooter,
    CardHeader
} from "reactstrap"

import BreadCrumb from "../Components/BreadCrumb"
import { useWallet } from "../libs/useMetaMaskWallet"
import ConnectWallet from "../Components/ConnectWallet"
import { api } from "../apis/validateStakerCode"
import { useToast } from "../hooks/toast"

const ValidateStakerCode = () => {
    const wallet = useWallet()
    const toast = useToast()
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [steps, setSteps] = useState([{ title: "Connect Wallet" }, { title: "Enter the code" }, { title: "Result" }])

    const [currentStep, setCurrentStep] = useState(0)

    const [loading, setLoading] = useState(false)
    const [stakes, setStakes] = useState(null)
    const [account, setAccount] = useState("")
    const [code, setCode] = useState("")

    const handleInputCode = (e) => {
        let value = e.target.value
        setCode(value)
    }

    const handleData = (data) => {
        let stakes = {
            discordUserName: data.discordUserName,
            stakes: data.stakes
        }

        setStakes(stakes)
    }

    const onSubmit = async () => {
        setStakes(null)
        setLoading(true)
        let response
        try {
            response = await api.validate(wallet.account, code)
            if (response && response.data) {
                handleData(response.data)
                toast.addSuccess("Your validation has been processed")
            } else {
                toast.addError("The code is not valid or has expired")
            }
        } catch (error) {
            toast.addError("An error has occurred")
            console.log(error)
            setLoading(false)
        }
        setLoading(false)
    }

    useEffect(() => {
        ;(async () => {
            setIsConnectedToWallet(wallet.status === "connected")
            if (wallet.account) {
                try {
                    setAccount(wallet.account)
                } catch (err) {
                    console.log(err)
                }
            }
        })()
    }, [wallet.status, wallet.account])

    useEffect(() => {
        if (!account) {
            setCurrentStep(0)
        }
        if (account) {
            setCurrentStep(1)
        }
        if (stakes) {
            setCurrentStep(2)
        }
        return () => {}
    }, [account, stakes])

    const stepsComponent = () => {
        return (
            <Row>
                <Col>
                    <Card>
                        <Stepper
                            size={46}
                            completeColor={"#34c38f"}
                            completeTitleOpacity={"0.5"}
                            activeColor={"#f95936"}
                            steps={steps}
                            activeStep={currentStep}
                        />
                    </Card>
                </Col>
            </Row>
        )
    }

    const resultComponent = () => {
        return (
            <Row>
                <Col>
                    <Card>
                        <Row>
                            <Col sm="12">
                                <Card className="text-center m-3">
                                    <CardBody>
                                        <CardTitle className="h3">Validation Result</CardTitle>
                                        <CardBody>
                                            <CardText>Discord Username: {stakes.discordUserName}</CardText>
                                            {stakes.stakes.map((stake) => {
                                                return (
                                                    <CardText key={stake.poolName}>
                                                        {stake.poolName} Staked Amount: {stake.stakedAmount}
                                                    </CardText>
                                                )
                                            })}
                                        </CardBody>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        )
    }

    const connectComponent = () => {
        return (
            <>
                {!isConnectedToWallet ? (
                    <ConnectWallet wallet={wallet} onChange={() => setIsConnectedToWallet(wallet.status === "connected")} />
                ) : (
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <CardTitle className="h3">Connect Staker Wallet </CardTitle>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
            </>
        )
    }

    const validateComponent = () => {
        return (
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="h3">Validation Code</CardTitle>
                            <CardText>To continue the validation, enter the code below</CardText>
                            <CardBody>
                                <Input
                                    type="text"
                                    onFocus={(e) => e.target.select()}
                                    className="form-control w-100"
                                    style={{ textAlign: "left" }}
                                    onChange={(e) => handleInputCode(e)}
                                    value={code}
                                    disabled={loading}
                                ></Input>
                            </CardBody>
                            <CardBody>
                                <CardFooter className="text-center">
                                    <div className="flex justify-content-end">
                                        <Button color="primary" className="waves-effect w-xl btn-submit" onClick={() => onSubmit()}>
                                            Send
                                        </Button>
                                    </div>
                                </CardFooter>
                            </CardBody>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }

    return (
        <React.Fragment>
            <div className="content integrate-nfts">
                <BreadCrumb current="Validate Staker Code" />
                {stepsComponent()}
                {!account ? connectComponent() : stakes ? resultComponent() : validateComponent()}
            </div>

            <Modal isOpen={loading} centered={true}>
                <ModalHeader tag="h2">Validating the code</ModalHeader>
                <ModalBody tag="h3">Please wait...</ModalBody>
                <ModalBody className="text-center">
                    <Spinner
                        style={{
                            width: "50px",
                            height: "50px"
                        }}
                        color="dark"
                    />
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default ValidateStakerCode
